import { useContext } from 'react';
import { DarkModeContext } from './DarkModeContext.ts';

export function useDarkMode() {
  return useContext(DarkModeContext);
}
